import { useQuery } from "react-query";
import { getActionRequired } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";

export const useGetActionRequired = () => {
  return useQuery("GetActionRequired", getActionRequired, {
    refetchOnWindowFocus: false,
  });
};
